$(function() {
    scrollToGlobal(".ego-c-pmg-hero-anchor", ".ego-c-pmg-step-describe");
});